module.exports = __webpack_public_path__ + "static/media/boy_boxers.680cdf4d.jpg";